import {
  CheckIcon,
  LockClosedIcon,
  XMarkIcon,
} from '@heroicons/react/16/solid';
import { useEffect } from 'react';
import { Button, Modal } from 'react-daisyui';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { RouterPaths } from '../../../../components/Router/Router.constants';
import { useSubscriptionAnalytics } from 'src/hooks/analytics/subscription/useSubscriptionAnalytics.hook';
import { SettingsTabs } from '../../../../pages/Settings/Settings.enum';
import { useModalsContext } from '../../../ModalsProvider/Modals.context';
import { useSubscriptionContext } from '../../Subscription.context';

export default function SubscribeImportLeadsModal() {
  const { showSubscribeImportLeadsModal, setShowSubscribeImportLeadsModal } =
    useModalsContext();
  const navigate = useNavigate();
  const { t } = useTranslation('subscription/modals');
  const { setUpInfo, getPlans } = useSubscriptionContext();
  const { trackPurchaseCta } = useSubscriptionAnalytics();

  // BUG-868: nothing auto-fetches plans on active workspaces — without this
  // the title interpolated a blank price. Mounted on open; RET-1190 guards
  // concurrent calls.
  useEffect(() => {
    if (!setUpInfo) void getPlans();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Modal
      open={showSubscribeImportLeadsModal}
      onClose={() => setShowSubscribeImportLeadsModal(false)}
      className="SubscribeImportLeadsModal"
    >
      <Modal.Body className="SubscribeImportLeadsModal__content">
        <div className="SubscribeImportLeadsModal__left_side">
          {/* This button is only visible on sm screens using tailwind */}
          <Button
            shape="circle"
            size="sm"
            color="ghost"
            variant="outline"
            className="SubscribeImportLeadsModal__left_side__button"
            onClick={() => setShowSubscribeImportLeadsModal(false)}
          >
            <XMarkIcon className="SubscribeImportLeadsModal__right_side__icon" />
          </Button>
          <div className="SubscribeImportLeadsModal__left_side__warning">
            <LockClosedIcon className="w-6 h-6" />
            <p className="text-sm font-medium">
              {t('importLeads.subscriptionWarning')}
            </p>
          </div>
          <p className="SubscribeImportLeadsModal__left_side__title">
            {setUpInfo ? (
              <Trans
                i18nKey="subscription/modals:importLeads.title"
                components={{ span: <span className="text-accent" /> }}
                values={{
                  setUpPrice: setUpInfo.trialCost,
                  currency: setUpInfo.currency,
                }}
              />
            ) : (
              <Trans
                i18nKey="subscription/modals:importLeads.titleNoPrice"
                components={{ span: <span className="text-accent" /> }}
              />
            )}
          </p>
          <div className=" overflow-auto h-[300px] sm:h-full">
            <div className="SubscribeImportLeadsModal__left_side__features">
              <p>{t('importLeads.subtitle')}</p>
              <div className="SubscribeImportLeadsModal__left_side__feature">
                <CheckIcon className="w-6 h-6" />
                <p>
                  <Trans
                    i18nKey="subscription/modals:importLeads.features.feature1"
                    components={{ span: <span className="font-bold" /> }}
                  />
                </p>
              </div>
              <div className="SubscribeImportLeadsModal__left_side__feature">
                <CheckIcon className="w-6 h-6" />
                <p>
                  <Trans
                    i18nKey="subscription/modals:importLeads.features.feature2"
                    components={{ span: <span className="font-bold" /> }}
                  />
                </p>
              </div>
              <div className="SubscribeImportLeadsModal__left_side__feature">
                <CheckIcon className="w-8 h-8" />
                <p>
                  <Trans
                    i18nKey="subscription/modals:importLeads.features.feature3"
                    components={{ span: <span className="font-bold" /> }}
                  />
                </p>
              </div>
            </div>
            {setUpInfo && (
              <p className="text-xs mt-4">
                <Trans
                  i18nKey="subscription/modals:importLeads.disclaimer"
                  components={{
                    b: <b />,
                    br: <br />,
                  }}
                  values={{
                    fullPrice: setUpInfo.monthlyPrice.toLocaleString('en-US', {
                      style: 'currency',
                      currency: 'USD',
                    }),
                    currency: setUpInfo.currency,
                  }}
                />
              </p>
            )}
          </div>
          <Button
            color="primary"
            className="w-full"
            onClick={() => {
              navigate(
                `${RouterPaths.settings}?section=${SettingsTabs.SUBSCRIPTION}&cta_type=ImportLeads`,
              );
              trackPurchaseCta('ImportLeads', 'ImportLeads');
              setShowSubscribeImportLeadsModal(false);
            }}
          >
            Activa tu plan hoy
          </Button>
        </div>
        <div className="SubscribeImportLeadsModal__right_side">
          <Button
            shape="circle"
            size="sm"
            color="ghost"
            className="SubscribeImportLeadsModal__right_side__closeButton"
            onClick={() => setShowSubscribeImportLeadsModal(false)}
          >
            <XMarkIcon className="SubscribeImportLeadsModal__right_side__icon" />
          </Button>
          <img
            src="/images/subscriptions/ImportLeads.png"
            alt="leadsales-logo"
            className="SubscribeImportLeadsModal__right_side__image"
          />
        </div>
      </Modal.Body>
    </Modal>
  );
}
